import { useGetAlboCfgTipi } from '@framework/common-web/register-records/frontoffice/api/configurazione-tipo-albo/configurazione-tipo-albo.ts';
import { useMemo } from 'react';

/**
 * Hook per ottenere la configurazione del Tipo Albo a partire dal record verificato.
 */
export function useVerifyPassRegisterRecordsType(idTipoAlbo?: string | null) {
  const { data: tipiAlbo } = useGetAlboCfgTipi({
    query: { enabled: !!idTipoAlbo },
  });

  return useMemo(() => {
    if (!(tipiAlbo && idTipoAlbo)) return null;
    return tipiAlbo.find(t => t.id === idTipoAlbo) ?? null;
  }, [tipiAlbo, idTipoAlbo]);
}
